import { c as _c } from "react/compiler-runtime";
import { Button } from '@mui/material';
type Props = {
  onLoginHandler: CallableFunction;
};
export default function LoginWithAzure(t0) {
  const $ = _c(2);
  const {
    onLoginHandler
  } = t0;
  let t1;
  if ($[0] !== onLoginHandler) {
    t1 = <Button variant="contained" fullWidth={true} onClick={() => onLoginHandler()}>Sign in with Azure AD</Button>;
    $[0] = onLoginHandler;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}